<template>
  <router-view />
</template>

<script>
export default {
  name: 'App',
};
</script>

<style>
*, *::before, *::after {
  box-sizing: border-box;
}
html {
  overflow-x: hidden;
}
body {
  margin: 0;
  font-family: 'Segoe UI', Arial, sans-serif;
  overflow-x: hidden;
  -webkit-text-size-adjust: 100%;
}
img {
  max-width: 100%;
  height: auto;
}
</style>

